import React from 'react'
import ReactDOM from 'react-dom'
import {Box, BoxProps, useMultiStyleConfig} from '@chakra-ui/react'

interface DarkOverlayProps {
    variant?: 'headerMenu'
}

/**
 * @name DarkOverlay
 *
 * @component
 *
 * @description
 * Renders a dark overlay using React Portal to ensure it is rendered outside
 * the main DOM hierarchy, directly into the document body.
 *
 * @returns {React.FC<DarkOverlayProps>} A fixed-position Box element with a semi-transparent black background.
 */
const DarkOverlay: React.FC<DarkOverlayProps> = ({variant}) => {
    const styles = useMultiStyleConfig('DarkOverlay', {variant}) as Record<string, BoxProps>

    return ReactDOM.createPortal(<Box data-testid="dark-overlay" {...styles.overlay} />, document.body)
}

export {DarkOverlay}
